import React from 'react'
import { supportsRecipientNameToggle } from './formFieldTypes'

const RecipientNameLabelIcon: React.FC<{ element: any }> = ({ element }) => {
  if (!supportsRecipientNameToggle(element) || element?.useAsRecipientName !== true) {
    return null
  }

  return (
    <i
      className='bi bi-envelope-fill ms-2 align-middle'
      title='Used in email greeting'
      aria-label='Used in email greeting'
      style={{ fontSize: '0.85em', color: '#98059d', opacity: 0.9 }}
    />
  )
}

export default RecipientNameLabelIcon
